<div class="login-wrapper">
  <div id="login-container">
    <div class="login-title">Steam Leaks</div>
    <div class="login-subtitle">For Manufacturing</div>
    <button class="em-c-btn" *ngIf="!auth.isAuthenticated()" (click)="auth.login(0)">
      <span class="em-c-btn__text">ExxonMobil Single Sign-On</span>
    </button>

    <button class="em-c-btn" *ngIf="!auth.isAuthenticated()" (click)="auth.login(1)">
      <span class="em-c-btn__text">Third-Party Login</span>
    </button>
    
    <button style="display:none" class="em-c-btn" *ngIf="!auth.isAuthenticated()" (click)="auth.login(2)">
      <span class="em-c-btn__text">Super-Secret Login 🙈 🤫</span>
    </button>

    <button class="em-c-btn" *ngIf="auth.isAuthenticated()" (click)="auth.logout()">
      <span class="em-c-btn__text">Logout</span>
    </button>
  </div>
</div>
